/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

interface RemoveArchivedScopeModalProps {
  handleSubmit: () => void;
  handleClose: () => void;
}

export const RemoveArchivedScopeModal = ({ handleSubmit, handleClose }: RemoveArchivedScopeModalProps) => {
  return (
    <Modal isOpen={true} toggle={handleClose} backdrop='static'>
      <ModalHeader toggle={handleClose}>Removing archived scope pack</ModalHeader>
      <ModalBody>
        You are about to remove an archived scope pack from your survey scope selection. Once removed you will not be
        able to re-add this scope pack to your surveys scope. Do you wish to continue?
      </ModalBody>
      <ModalFooter>
        <Button color='link-secondary' className='mr-2' onClick={handleClose}>
          Cancel
        </Button>
        <Button color='danger' onClick={handleSubmit}>
          Remove pack
        </Button>
      </ModalFooter>
    </Modal>
  );
};
